import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'NodeTag' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 8,
        borderRadius: 8,
        border: '1px solid #ECECEC',
        background: '#FFF'
    }
});
